<div class="toggle-icon"
     [ngClass]="{'toggled': isChecked, 'disabled': isDisabled}"
     (click)="toggle()"
     [style.cursor]="isDisabled ? 'not-allowed' : 'pointer'">
  <i class="fa"
     [ngClass]="isChecked ? 'fa-toggle-on' : 'fa-toggle-off'"
     style="font-size: 18px;"></i>
</div>